import {StackItem} from '../../interfaces/router/stackItem';
import screens from '../../config/screens';
import OnBoarding from '../../screens/auth/onboarding';
import {createLazyComponent} from '../../utils/lazyLoad';

// Create lazy loaded component
const LazyOnBoarding = createLazyComponent(OnBoarding);

/**
 * An array of onboarding routes for a navigation stack.
 * @type {StackItem[]}
 */
const onboardingRoutes: StackItem[] = [
  {
    name: screens.onboarding,
    component: LazyOnBoarding,
    options: {
      headerShown: false,
      animation: 'fade',
    },
  },
];
export default onboardingRoutes;
